// extracted by mini-css-extract-plugin
export var bodySections = "_d6-8";
export var gray = "_d6-7";
export var green = "_d6-4";
export var iconContainer = "_d6-9";
export var iconWidgetContainer = "_d6-1";
export var phoneIcon = "_d6-2";
export var red = "_d6-5";
export var statusDot = "_d6-3";
export var widgetContainer = "_d6-0";
export var yellow = "_d6-6";